import axios from 'axios';
import { lsGet, lsDel } from './api';
import { isNativeApp } from './native';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const STORE_TOKEN_KEY = 'sahakar_store_token'; // migration only
export const STORE_INFO_KEY = 'sahakar_store_info';
let info = null;
let nativeToken = '';
let migration;

// A counter opened from head office keeps its token in this window's own
// sessionStorage — never a cookie — so the outlet's counter and any other tab
// stay signed in exactly as they were.
const OPENED_TOKEN_KEY = 'sahakar_store_opened_token';
const OPENED_BY_KEY = 'sahakar_store_opened_by';
const ss = (fn) => { try { return fn(sessionStorage); } catch { return null; } };
export const openedToken = () => ss((s) => s.getItem(OPENED_TOKEN_KEY)) || '';
export const openedBy = () => ss((s) => s.getItem(OPENED_BY_KEY)) || '';
export function saveOpenedSession(token, who) {
  ss((s) => { s.setItem(OPENED_TOKEN_KEY, token); s.setItem(OPENED_BY_KEY, who || 'head office'); });
}

export const storeApi = axios.create({ baseURL: API, withCredentials: true,
  headers: { 'Content-Type': 'application/json' } });
storeApi.interceptors.request.use((config) => {
  // Let the browser/axios generate the multipart boundary for Counter uploads.
  // The JSON default must not be sent with FormData or FastAPI cannot see `file`.
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
    delete config.headers['content-type'];
  }
  const token = openedToken() || nativeToken;
  if (token) config.headers['X-Store-Token'] = token;
  return config;
});
storeApi.interceptors.response.use((res) => res, (error) => {
  const detail = String(error.response?.data?.detail || '');
  if (error.response?.status === 401 && /session|signed in|signed out/i.test(detail)) {
    endStoreSession();
    if (!window.location.search.includes('mode=store')) window.location.assign('/login?mode=store');
  }
  return Promise.reject(error);
});

export async function restoreStoreSession() {
  if (migration) return migration;
  const legacy = lsGet(STORE_TOKEN_KEY);
  migration = (async () => {
    try {
      if (legacy) await storeApi.post('/store/auth/migrate-session', {}, { headers: { 'X-Store-Token': legacy } });
    } finally {
      lsDel(STORE_TOKEN_KEY); lsDel(STORE_INFO_KEY);
    }
    const { data } = await storeApi.get('/store/auth/me');
    info = data;
    return data;
  })().finally(() => { migration = null; });
  return migration;
}

export const storeInfo = () => info;
export function saveStoreSession(token, store) {
  nativeToken = isNativeApp() ? token : '';
  info = store;
  lsDel(STORE_TOKEN_KEY); lsDel(STORE_INFO_KEY);
}
export function endStoreSession() {
  info = null; nativeToken = '';
  lsDel(STORE_TOKEN_KEY); lsDel(STORE_INFO_KEY);
  ss((s) => { s.removeItem(OPENED_TOKEN_KEY); s.removeItem(OPENED_BY_KEY); });
}
export function storeError(e, fallback = 'Something went wrong') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || '').join(' ') || fallback;
  return fallback;
}
export const rupees = (n) => `₹${Number(n || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;